import React from 'react';

export default function TermsDeclined() {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <span style={styles.icon}>🍷</span>
        <h1 style={styles.title}>Terms Declined</h1>
        <p style={styles.text}>
          You have chosen not to accept the Winesup Terms and Conditions.
          Unfortunately, we are unable to provide access to the service without your acceptance.
        </p>
        <p style={styles.text}>
          If you change your mind, you are welcome to return and accept the Terms at any time.
        </p>
        <button onClick={() => window.location.href = '/'} style={styles.btn}>
          Return to Winesup
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
    background: 'linear-gradient(135deg, #1a1a2e 0%, #4a1528 100%)', padding: '20px',
  },
  card: {
    background: '#fff', borderRadius: '12px', padding: '48px', maxWidth: '480px',
    width: '100%', textAlign: 'center', boxShadow: '0 20px 60px rgba(0,0,0,0.3)',
  },
  icon: { fontSize: '3rem' },
  title: { fontSize: '1.8rem', color: '#1a1a1a', margin: '16px 0 8px' },
  text: { color: '#555', lineHeight: '1.6', margin: '0 0 16px' },
  btn: {
    marginTop: '16px', padding: '12px 32px', background: '#722F37', color: '#fff',
    border: 'none', borderRadius: '8px', cursor: 'pointer', fontSize: '1rem', fontWeight: 600,
  },
};
